
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources04 as ObiSources04Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-04.js';
 
 
 

 
 export const ObiSources04 = createComponent({
   react: React,
   tagName: 'obi-sources-04',
   elementClass: ObiSources04Element,
   events: {
     
   }
  });
 
 